<template>
  <b-row>
    <b-col md="12">
      <hr />
      <h6 class="pack-name">{{pack.name}}</h6>
      <p v-if="pack.description">
        <small>{{ pack.description }}</small>
      </p>
      <div class="table-responsive mb-0">
        <table class="table table-sm border table-hover">
          <thead class="t-head hh-t-head">
            <td>Tip camera</td>
            <td style="width:5px">&nbsp;</td>
            <td>Tip masa</td>
            <td>Pret catalog</td>
            <td>Pret redus</td>
            <td>Tip oferta</td>
            <td>Alege</td>
          </thead>
          <tbody>
            <category
              v-for="(category, categoryIndex) in pack.categories"
              :categoryIndex="categoryIndex"
              :category="category"
              :currency="currency"
              :key="'c' + categoryIndex"
              :transport="transport"
              @book="$emit('book',{ categoryId: category.id, ...$event })"
              @priceDetails="$emit('priceDetails', {category, ...$event})"
            />
          </tbody>
        </table>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import category from '@/app/private/shared/components/category_result'

export default {
  props: ['pack', 'packageIndex', 'currency', 'transport'],
  components: { category }
}
</script>
